import {createApi,fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig} from 'axios';
import { CoinGeckoCoinMarketChartParams, CoinGeckoCoinsMarketParams, CoinGeckoSimplePriceParams } from '../../../types/types';

const getCoins = async():Promise<[any,any]>=>{

    const url = "https://api.coingecko.com/api/v3";
    
        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "get",
                url: `${url}/coins/list`,
                
            };

            const response = await axios.request(axiosConfig);

            return [null,response.data]

        } catch (axiosError:any) {


            return [axiosError.response.data,null]
        }

}

const getCoinsMarket = async(params:CoinGeckoCoinsMarketParams):Promise<[any,any]>=>{

    const url = "https://api.coingecko.com/api/v3";
    
        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "get",
                params:params,
                url: `${url}/coins/markets`,
                
            };

            const response = await axios.request(axiosConfig);

            return [null,response.data]

        } catch (axiosError:any) {
            return [axiosError.response.data,null]
        }

}

const getCoinMarketChart = async (params:CoinGeckoCoinMarketChartParams):Promise<[any,any]>=>{

    const url = "https://api.coingecko.com/api/v3";
    
        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "get",
                params:{
                    vs_currency:params.vs_currency,
                    days:params.days,
                    interval:params.interval
                },
                url: `${url}/coins/${params.id}/market_chart`,
                
            };

            const response = await axios.request(axiosConfig);

            return [null,response.data]

        } catch (axiosError:any) {


            return [axiosError.response.data,null]
        }

}

const getSimplePrice = async (params:CoinGeckoSimplePriceParams):Promise<[any,any]>=>{

    const url = "https://api.coingecko.com/api/v3";
    
        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "get",
                params:params,
                url: `${url}/simple/price`,
                
            };

            const response = await axios.request(axiosConfig);

            return [null,response.data]

        } catch (axiosError:any) {
            return [axiosError.response.data,null]
        }


}


export const coinGeckoApi = createApi({
    reducerPath:"coingecko",
    baseQuery: fetchBaseQuery({ baseUrl: '/ ' }),
    endpoints: (builder) => ({
        getCoinsMarket: builder.query<any,CoinGeckoCoinsMarketParams>({   
            async queryFn(_arg){

                const [error,response] = await getCoinsMarket(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response}     
            },
        }),
        getCoinMarketChart: builder.query<any,CoinGeckoCoinMarketChartParams>({   
            async queryFn(_arg){

                const [error,response] = await getCoinMarketChart(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response}     
            },
        }),
        getSimplePrice: builder.query<any,CoinGeckoSimplePriceParams>({   
           
            async queryFn(_arg){

                const [error,response] = await getSimplePrice(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response}     
            },
        }),
        
    })
})

export const {useGetCoinsMarketQuery,useGetCoinMarketChartQuery,useGetSimplePriceQuery} = coinGeckoApi 